import {server_index} from './app.js'

let host_config = {
	test:[
		'https://chg3a793vor0019ysq5ou7hk2958dgem.2cccc.cc/'
	],
	production:[
		'https://chg3a793vor0019ysq5ou7hk2958dgem.2cccc.cc/',
	],
}

function normalizeHost(url) {
	if (!url) {
		return ''
	}
	let nextUrl = url.replace(/\/+$/, '')
	if (typeof window !== 'undefined' && window.location && window.location.protocol === 'https:') {
		nextUrl = nextUrl.replace(/^http:\/\//i, 'https://')
	}
	return nextUrl
}

let hosts = host_config[server_index].map(item => normalizeHost(item))
let host = hosts[0]

function resolveApiUrl(path = '') {
	if (!path) {
		return host
	}
	if (/^https?:\/\//i.test(path)) {
		return normalizeHost(path)
	}
	return host + '/' + path.replace(/^\/+/, '')
}

export {
	host,
	hosts,
	resolveApiUrl,
}
